import React, { Component } from 'react'
import CSSModules from 'react-css-modules'
import config from '../../config'
import { Link } from '../../components'
import Styles from './FooterPartner.css'

@CSSModules(Styles)
export default class FooterPartner extends Component {
  constructor(props){
    super(props)
  }
  render() {
    const equileapLogo = require( '../../../static/images/equileap-stamp.png' )

    return (
      <div styleName='logo-second-wrap'>
        <Link
          to={config.links.equileap}
          title='Equileap'>
          <img
            styleName={'logo-equileap'}
            src={equileapLogo}
            alt='Equileap'
          />
        </Link>
      </div>
    )
  }
}
